/**
 * Live go-e wallbox power in W, shared by the server and the dashboard.
 *
 * API v2 `nrg[11]` is the total power. `wo` is not live: it froze at 10 102 W when the
 * box lost L3 on 2026-10-04 and stayed there through the phase error that followed, so
 * the dashboard showed a car charging that was not and the solar balance counted it as
 * 10 kW of surplus. Only a box reporting car state 2 (charging) draws power.
 *
 * Returns null when the box reports nothing usable, so callers can fall back.
 */
export function goePowerW({ nrg, car, wo } = {}) {
  if (car != null && car !== '' && Number(car) !== 2) return 0
  let arr = nrg
  if (typeof arr === 'string') {
    try { arr = JSON.parse(arr) } catch { arr = null }
  }
  if (Array.isArray(arr) && arr[11] != null && Number.isFinite(Number(arr[11]))) return Number(arr[11])
  return wo != null && wo !== '' && Number.isFinite(Number(wo)) ? Number(wo) : null
}
